export default __webpack_public_path__ + "static/media/banner2.19419d69.jpg";